import React from 'react';
import ReactDOM from 'react-dom';
import {PlannerTeaserApp} from "./apps/PlannerTeaserApp";

let plannerTeaserRoots = document.getElementsByClassName('plannerTeaserRoot');

[].forEach.call(plannerTeaserRoots, function(plannerTeaserRoot){

    const linkToPlannerList = plannerTeaserRoot.getAttribute('data-list-pid');

    ReactDOM.render(
		<PlannerTeaserApp linkToPlannerList={linkToPlannerList} />,
        plannerTeaserRoot
    );
});


// WEBPACK FOOTER //
// ./src/plannerTeaser.js